import React, {Component, Fragment} from "react";
import {Button, Col, FormGroup, Input, Label, Nav, NavItem, NavLink, Row, TabContent, TabPane} from "reactstrap";
import {toast, ToastContainer} from "react-toastify";
import {
  dateHelper,
  formsDataUpdater,
  formsMultiUpdater,
  formsUpdater,
  getFormFieldValue
} from "../../Applications/shared/shared";
import classnames from 'classnames';
import {EventClient} from "../../../util/eventClient";
import {LMSUserPicker} from "../../../components/LMSUserPicker/LMSUserPicker";
import {deleteData, getData, postData} from "../../../api/doLogin";
import {LMSUserOrPicker} from "../../../components/LMSUserPicker/LMSUserOrPicker";
import {SafeZoomImage} from "../../../components/Shared/SafeZoomImage";
import {getBCStatus, getBCStatusList, MonthNames} from "../../../constants/BCConstants";
import {SafeImage} from "../../../components/Shared/SafeImage";
import {BriefcaseAddToLMS} from "./BriefcaseAddToLMS";
import {getGlobalState} from "../../../constants/GlobalStore";
import {DropSelection} from "../../Leads/components/DropSelection";

export default class BriefcaseEntryEditor extends Component {

  constructor(props) {
    super(props);
    this.state = {
      appttypes: [],
      dataLoaded: false,
      formData: {}, // Left off here. Make edit be ID and retrieve Entry data with appt Constants.
      url: null,
      edit: [],
      notes: [],
      agenciesList: [],
      showLMSPicker: false,
      activeTab: "1",
      calendarMenu: [],
      callbackPicker: []
    };
    // console.log("Loaded fileeditor");
  }

  componentWillMount() {
    EventClient.on(this.props.saveEvent, () => this.saveExternal(), this.props.eventName);
    EventClient.on(this.props.deleteEvent, () => this.deleteExternal(), this.props.eventName);
    this.getDBConstants();

  }

  componentWillUnmount() {
    EventClient.off(this.props.saveEvent, () => this.saveExternal(), this.props.eventName);
    EventClient.off(this.props.deleteEvent, () => this.deleteExternal(), this.props.eventName);
  }

  saveExternal() {
    // console.log(this.state.formData);
    this.save((resp) => {
      if (this.props.onSave) {
        this.props.onSave(resp);
      }
    })
  }

  deleteExternal() {
    deleteData(`briefcase/${this.props.folderId || 0}/${this.props.edit || 0}`, {}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          EventClient.emit("BRIEFCASE_REFRESH", this.props.folderId || 0);
          EventClient.emit("NAVIGATE", `/briefcase/${this.props.folderId || 0}`);
        }
      }).catch((error) => {
      console.log(error);
    });
  }

  saveInternval() {

  }

  downloadFile() {
    if (!this.props.edit || this.props.edit === 0) return;
    const self = this;
    getData(`briefcase/${this.props.folderId || 0}/${this.props.edit || 0}/download`, {}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          // console.log(data.data);
          if (data.data.url !== null) {
            window.open(data.data.url, "_blank");
          } else {
            toast.error("Could not download");
          }
        } else {
          toast.error("Could not download");
        }
      }).catch((error) => {
      console.log(error);
      toast.error("Could not download");
    });
  }

  getDBConstants() {
    // console.log(this.props.edit);
    if (!this.props.edit || this.props.edit === 0) return;
    const self = this;
    getData(`briefcase/${this.props.folderId || 0}/${this.props.edit || 0}`, {}, this.props.token)
      .then((data) => {
        const buildPickerList = (agencies, months) => {
          // I want map of callbackAgencies like [{id: 1, display: "Agency Name"}] to map with monthnames like ['January', 'February', 'March'] to flatten to [{id: '1-1', display:'Agency Name -> January'}, {id: '1-2', display:'Agency Name -> February'}]
          let pickerList = [];
          agencies.forEach((agency) => {
            months.forEach((month, i) => {
              pickerList.push({
                id: `${agency.id}-${i + 1}`,
                display: `${agency.display} -> ${month}`
              })
            })
          });
          return pickerList;
        }
        if (data.status === "Success") {
          // console.log(data.data);
          let responseStateData = {
              notes: data.data.notes,
              formData: data.data.file,
              calendarMenu: data.data.calendarMenu || [],
              url: data.data.url,
              agenciesList: data.data.callbackAgencies,
              callbackPicker: buildPickerList(data.data.callbackAgencies, MonthNames),
              dataLoaded: true
            }
          ;
          self.setState(responseStateData);
        }
      }).catch((error) => {
      console.log(error);
    });
  }

  convertstorage() {
    const self = this;
    postData(`briefcase/${this.props.folderId || 0}/${this.props.edit || 0}/storageconvert`, {}, this.props.token)
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          self.getDBConstants();
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  save(cb) {
    const payload = {formData: this.state.formData || null};
    if (!payload.formData.filename.endsWith(`.${payload.formData.ext}`)) {
      payload.formData.filename = payload.formData.filename.concat(`.${payload.formData.ext}`);
    }
    //console.log(payload);
    // return cb(null);
    const self = this;
    postData(`briefcase/${this.props.folderId || 0}/${this.props.edit || 0}/save`, payload, this.props.token)
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          cb({...self.state.formData});
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  convertPDF() {
    const self = this;
    self.setState({dataLoaded: false});
    postData(`briefcase/${this.props.folderId || 0}/${this.props.edit || 0}/pdfconvert`, {}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          // console.log(data.data);
          EventClient.emit("NAVIGATE", `/briefcase/${this.props.folderId || 0}`);
          EventClient.emit("BRIEFCASE_REFRESH", this.props.folderId || 0);
        } else {
          // console.log(data.message, data.data);
          toast.error("There was an error with the conversion");
          self.setState({dataLoaded: true});
        }
      }).catch((error) => {
      console.log(error);
      toast.error("There was an error with the conversion");
      self.setState({dataLoaded: true});
    });
  }

  AgencyName(agencyId) {
    let agencyName = "None";
    this.state.agenciesList.forEach((agency) => {
      if (agency.id === agencyId) {
        agencyName = agency.display;
      }
    });
    return agencyName;
  }

  MonthName(id) {
    let monthName = "";
    MonthNames.forEach((name, index) => {
      if (index + 1 === id) {
        monthName = name;
      }
    });
    return monthName;
  }

  render() {
    if (!this.state.dataLoaded) {
      return <Fragment>Loading
        <div className="sk-three-bounce">
          <div className="sk-child sk-bounce1"></div>
          <div className="sk-child sk-bounce2"></div>
          <div className="sk-child sk-bounce3"></div>
        </div></Fragment>;
    }
    const containerStyle = {
      zIndex: 1999
    };

    const callbackDropDownValue = (cbAgency, cbMonth) => `${cbAgency}-${cbMonth}`;
    const callbackDropDownValueSplit = (value) => value && value.split("-") || [0, 0];

    let imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];

    if (this.props.fullView && this.props.setFullView) {
      return <Fragment>
        <div style={{height: "70vh", overflowY: "auto", width: "100%", margin: "0 auto"}}>
          <SafeImage src={this.state.url}/>
        </div>
        <div style={{height: "25vh"}}>
          <BriefcaseAddToLMS fileData={this.state.formData}
                             setFileData={(data) => {
                               this.setState({formData: {...this.state.formData, ...data}});
                             }}
                             onAddSuccess={() => {
                               EventClient.emit("BRIEFCASE_REFRESH", this.props.folderId);
                               this.getDBConstants();
                               this.props.setFullView(false);
                             }}
                             onClose={() => this.props.setFullView(false)}/>
        </div>
      </Fragment>
    }

    let calendarMenu = (this.state.calendarMenu || []).filter((cal) => cal.fwrite === 1).map((cal) => ({
      display: `${cal.fname} ${cal.lname}`.trim(),
      value: cal.uid
    })).sort((a, b) => a.display.localeCompare(b.display));

    return (
      <Fragment>
        <ToastContainer position="bottom-right" autoClose={1500} style={containerStyle}/>
        {this.state.showLMSPicker && (
          <LMSUserPicker isOpen={true} onClose={() => this.setState({showLMSPicker: false})}
                         onSelect={(lead) => this.attachLMSEntry(lead)}/>
        )}
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({active: this.state.activeTab === '1'})}
              onClick={() => this.toggleTab('1')}>
              General
            </NavLink>
          </NavItem>
          {this.state.formData.lmsID > 0 && (
            <NavItem>
              <NavLink
                className={classnames({active: this.state.activeTab === '2'})}
                onClick={() => this.toggleTab('2')}>
                Shared Notes
              </NavLink>
            </NavItem>
          )}
        </Nav>
        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="1">
            <Row>
              <Col xs="12" md="6">
                <FormGroup>
                  <Label for="filename">File</Label>
                  {this.state.edit.indexOf("filename") === -1 ?
                    <div id={"filename"} style={{display: "flex"}}>
                      {this.state.formData.filename}
                      <i className={"icon-pencil"}
                         style={{cursor: "pointer", marginLeft: 10}}
                         onClick={() => this.setState({edit: this.state.edit.concat("filename")})}/></div>
                    :
                    <Input
                      type="text"
                      id="filename"
                      value={getFormFieldValue(this.state.formData['filename'])}
                      onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                    />
                  }
                </FormGroup>
                <FormGroup>
                  <Label for="sizeMB">Size (MB)</Label>
                  <div id={"sizeMB"} style={{display: "flex"}}>
                    {this.state.formData.sizeMB}
                  </div>
                </FormGroup>
                <FormGroup>
                  <Label for="folderPath">Folder Path</Label>
                  <div id={"folderPath"} style={{display: "flex", fontSize: 10}}>
                    {this.state.formData.folderPath}
                  </div>
                </FormGroup>
                <FormGroup>
                  <Label for="source">Source</Label>
                  {this.state.edit.indexOf("source") === -1 ?
                    <div id={"source"} style={{display: "flex"}}>
                      {this.state.formData.source}
                      <i className={"icon-pencil"}
                         style={{cursor: "pointer", marginLeft: 10}}
                         onClick={() => this.setState({edit: this.state.edit.concat("source")})}/></div>
                    :
                    <Input
                      type="text"
                      id="source"
                      value={getFormFieldValue(this.state.formData['source'])}
                      onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                    />
                  }
                </FormGroup>

                <FormGroup>
                  <Label for="status">Status</Label>
                  {this.state.edit.indexOf("status") === -1 ?
                    <div id={"source"} style={{display: "flex"}}>
                      {getBCStatus(this.state.formData.status).display}
                      <i className={"icon-pencil"}
                         style={{cursor: "pointer", marginLeft: 10}}
                         onClick={() => this.setState({edit: this.state.edit.concat("status")})}/></div>
                    :
                    <Input type="select" id="status" placeholder=""
                           value={getFormFieldValue(this.state.formData['status'])}
                           onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                    >
                      {getBCStatusList().map((val, i) => {
                        return <option key={i} value={val.id}>{val.display}</option>
                      })}
                    </Input>
                  }
                </FormGroup>
                <FormGroup>
                  <Label for="status">Callback Folder</Label>
                  {this.state.edit.indexOf("callback") === -1 ?
                    <div id={"callback"} style={{display: "flex"}}>
                      {this.state.formData.cbAgency === 0 && this.state.formData.cbMonth === 0 ? "N/A" : `${this.AgencyName(this.state.formData.cbAgency)} -> ${this.MonthName(this.state.formData.cbMonth)}`}
                      <i className={"icon-pencil"}
                         style={{cursor: "pointer", marginLeft: 10}}
                         onClick={() => this.setState({edit: this.state.edit.concat("callback")})}/>
                      {this.state.formData.cbAgency !== 0 && this.state.formData.cbMonth !== 0 && (
                        <i className={"cil-delete"}
                           title={"Clear Date"}
                           style={{cursor: "pointer", marginLeft: 10}}
                           onClick={() => {
                             formsMultiUpdater({cbAgency: 0, cbMonth: 0}, this.state['formData'], this)
                           }}/>
                      )}
                    </div>
                    :
                    <div style={{display: "flex", alignItems: "center"}}>
                      <Input
                        type="select"
                        id="callback"
                        value={callbackDropDownValue(this.state.formData['cbAgency'], this.state.formData['cbMonth'])}
                        onChange={(evt) => {
                          const [cbAgency, cbMonth] = callbackDropDownValueSplit(evt.target.value);
                          formsMultiUpdater({'cbAgency': cbAgency, cbMonth: cbMonth}, this.state['formData'], this)
                        }}
                      >
                        <option disabled={true} value={"0-0"}>Please select...</option>
                        {this.state.callbackPicker.map((val, i) => {
                          return <option key={`${i}`} value={val.id}>{val.display}</option>
                        })}
                      </Input>
                      <i className={"cil-delete"}
                         title={"Clear Date"}
                         style={{cursor: "pointer", marginLeft: 10}}
                         onClick={() => {
                           formsMultiUpdater({cbAgency: 0, cbMonth: 0}, this.state['formData'], this, () => {
                             this.setState({edit: this.state.edit.filter((val) => val !== "callback")});
                           })
                         }}/>
                    </div>
                  }
                </FormGroup>

                <FormGroup>
                  <Label for="location">LMS Entry</Label>
                  <LMSUserOrPicker
                    token={this.props.token}
                    lmsID={this.state.formData['lmsID']}
                    onAttachLead={() => this.showAttachLMSPicker()}
                    onViewLead={(id) => EventClient.emit("LMS_ENTRY_EDIT", id)}
                    onRemoveLead={() => formsDataUpdater('lmsID', 0, this.state['formData'], this)}
                  />
                  {/*{typeof getFormFieldValue(this.state.formData['attachedLeads']) === "object" ? (*/}
                  {/*  <Fragment>*/}
                  {/*    {`${getFormFieldValue(this.state.formData['attachedLeads']['fname'])} ${getFormFieldValue(this.state.formData['attachedLeads']['lname'])}`}*/}
                  {/*    <Button color="link" className="px-0"*/}
                  {/*            onClick={() => formsDataUpdater('attachedLeads', undefined, this.state['formData'], this)}>Remove</Button>*/}
                  {/*  </Fragment>*/}
                  {/*) : (*/}
                  {/*  <Button onClick={() => this.showAttachLMSPicker()}>Attach Lead</Button>*/}
                  {/*)}*/}
                  {typeof this.state.formData['lmsID'] !== "undefined" && this.state.formData['lmsID'] > 0 && (
                    <DropSelection displayText={"Schedule"}
                                   items={{
                                     calendar: {
                                       header: "Select Calendar...",
                                       options: calendarMenu,
                                       selected: []
                                     }
                                   }}
                                   onClick={(category, value) => {
                                     window.open(`/calendar/${value || getGlobalState('loginID')}/schedule/${this.state.formData['lmsID']}`)
                                   }}
                    />
                  )}
                </FormGroup>
                {((!this.state.formData['sha1']) || (this.state.formData['sha1'] && this.state.formData['sha1'].length < 40)) && (
                  <Button onClick={() => this.convertstorage()}>Convert Storage</Button>
                )}

              </Col>
              <Col xs="12" lg="6">
                <div style={{
                  fontSize: 50,
                  display: "flex",
                }}>
                  {imageExtensions.indexOf(String(this.state.formData.ext || "").toLowerCase()) > -1 ?
                    <SafeZoomImage src={this.state.url}
                                   onFullView={() => this.props.setFullView && this.props.setFullView(true)}
                      // onClick={() => this.props.setFullView && this.props.setFullView(true)}
                    />
                    :
                    <div style={{fontSize: 18, display: "flex", flexDirection: "column"}}>
                      <Button color={"primary"} onClick={() => this.downloadFile()}>Download File</Button>
                      {String(this.state.formData.ext || "").toLowerCase() === "pdf" && (
                        <Button
                          color={"secondary"}
                          onClick={() => this.convertPDF()}
                        >Convert to JPG</Button>
                      )}
                    </div>
                  }

                  {/*<i style={{width: 50, height: 50, marginLeft: "auto", marginRight: "auto"}} className={"icon-ban"}/>*/}
                </div>
              </Col>
            </Row>

            {this.state.formData.lmsID === 0 && (
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="notes">File Comments</Label>
                    <Input
                      type="textarea"
                      id="notes"
                      cols={15}
                      style={{height: 150}}
                      value={getFormFieldValue(this.state.formData['notes'])}
                      onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                    />
                  </FormGroup>
                </Col>
              </Row>
            )}

          </TabPane>
          <TabPane tabId="2">
            <div style={{overflowX: "scroll", maxHeight: "65vh"}}>
              <table cellSpacing={5} cellPadding={5}>
                <thead>
                <tr>
                  <td style={{width: "25%"}}>User / Date</td>
                  <td style={{width: "75%"}}>Comment</td>
                </tr>
                </thead>
                <tbody>
                {this.state.notes && this.state.notes.map((note, index) => {

                  return <tr key={index} style={{paddingBottom: 10, borderBottom: "1px solid black"}}>
                    <td style={{width: "25%", verticalAlign: "top"}}>
                      {!note.FName && !note.LName ? "System User" : `${note.FName} ${note.LName}`}
                      <br/>
                      {dateHelper(new Date(note.date_time))}
                    </td>
                    <td style={{width: "75%", whiteSpace: "pre-wrap", verticalAlign: "top"}}>{note.notes}</td>
                  </tr>
                })}
                </tbody>
              </table>
            </div>
          </TabPane>
        </TabContent>
      </Fragment>
    )
  }

  showAttachLMSPicker() {
    this.setState({showLMSPicker: true});
  }

  attachLMSEntry(lead) {
    const obj = {
      // attachedLeads: lead,
      lmsID: lead.id
    }
    formsMultiUpdater(obj, this.state['formData'], this, () => {
      this.setState({showLMSPicker: false})
    });
  }
}


// WEBPACK FOOTER //
// ./src/containers/Briefcase/views/BriefcaseEntryEditor.js